<div class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
  <div class="title d-flex align-items-center">
    <button *ngIf="showBackButton" mat-icon-button [routerLink]="['../']"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <button *ngIf="showBackToDashboard" mat-icon-button (click)="goToBack()"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <button *ngIf="backWithParams" mat-icon-button (click)="goToBackWithParams()"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <button *ngIf="backWithAllParams" mat-icon-button (click)="goToBackWithAllParams()"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <button *ngIf="backLocation" mat-icon-button (click)="goToBackToLocation()"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <button *ngIf="back" mat-icon-button (click)="backButton()"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <button *ngIf="customBackforbusiness" mat-icon-button (click)="custombackforbusinessf()"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <button *ngIf="customBackforemployee" mat-icon-button (click)="custombackforemployeesf()"   class="me-3">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <div>
      <h1 *ngIf="pageTitle">{{pageTitle == 'Tax & GST' ? (pageTitle) : (pageTitle | titlecase)}}</h1>
      <h2 class="m-0 pagesubth" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
  
  <button *ngIf="showButton" mat-button (click)="onTitlebarButtonClick()">{{showButton}}</button>
</div>
